var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: {
      label: _vm.label,
      prop: _vm.prop,
      "class-name": "seats",
      sortable: _vm.sortable
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(scope) {
          return [_vm._v(" " + _vm._s(scope.row.seats.toLocaleString()) + " ")]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }